import { unsafeIntegerCentToFloatString } from "vincent-utils";

const FloatCentDisplayer = (props: { cent: number }) => {
  return <>{unsafeIntegerCentToFloatString(props.cent).replace(".", ",")}</>;
};

export default FloatCentDisplayer;
